<template>
  <div @click="selectedItem = null">
    <breadcrumbs home="Mash bill"/>

    <v-card flat>
      <v-form v-model="valid" ref="form">
        <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
          <v-row>
            <v-col cols="12" sm="5">
              <v-text-field label="Name" v-model="mashBill.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
            </v-col>
            <v-col cols="2">
              <v-checkbox label="Active" v-model="mashBill.active" dense class="mt-1"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="2">
              <decimal-number-input label="Volume" v-model="mashBill.volume" prefix="" suffix="litres" :precision="0" integer/>
            </v-col>
            <v-col cols="2" lg="1">
              <v-checkbox label="Scalable" dense v-model="mashBill.scalable" class="mt-1"/>
            </v-col>
            <v-col class="text-caption mt-3 ml-3" v-if="!$vuetify.breakpoint.mobile">
              If set, then mash bill items will be scaled up or down according to volume used at mash time
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" lg="9">
              <outlined-block title="Mash bill items" v-model="mashBill.items" :rules="[itemsNeeded]">
                <v-data-table width="100%" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                              :items="mashBill.items" item-key="itemId" no-data-text="At least one input item is required"
                              :headers="[{text:'',value:'add',width:'10%',align:'center',cellClass:'pa-0',divider:true},
                                          {text:'Item',value:'item',width:'36%',divider:true,class:'px-2',cellClass:'py-2 px-1'},
                                          {text:'Quantity',value:'quantity',width:'18%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'},
                                          {text:'Minimum',value:'minQuantity',width:'18%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'},
                                          {text:'Max (0 for no max)',value:'maxQuantity',width:'18%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'}]"
                              class="no-sort"
                              :item-class="item => item.key=== selectedItem ? ($vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4') : ''"
                              @click.native.stop=""
                              @click:row="item => {selectedItem = item.key; $nextTick(() => this.$refs.form.validate())}"
                              ref="tableBody">
                  <template v-slot:item.add="{index}">
                    <v-icon class="handle mt-n2">mdi-drag</v-icon>
                    <v-btn class="mt-n2" icon @click.stop="deleteItem(index)" x-small><v-icon>mdi-delete</v-icon></v-btn>
                  </template>
                  <template v-slot:item.item="{item}">
                    <template v-if="selectedItem === item.key">
                      <multi-level-select v-if="categories.length"
                                    :menuData="eligibleItems" :second.sync="item.itemId" actionEvent="addItem" actionText="Add new item"
                                    @addItem="inputItem=item;itemCreate=true" outlined label="Item"/>
                      <v-autocomplete v-else :rules="[itemValid]" dense label="Item" v-model="item.itemId" :items="items"
                                      item-value="id" item-text="name" class="text-body-2" no-data-text="No items found"
                                      outlined>
                        <template v-slot:prepend-item>
                          <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="inputItem=item;itemCreate=true">
                            <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new item
                          </div>
                        </template>
                      </v-autocomplete>
                    </template>
                    <div v-else class="pl-1" :class="{'error--text':!item.itemId}">
                      {{getItem(item).name}}
                    </div>
                  </template>
                  <template v-slot:item.quantity="{item}">
                    <decimal-number-input v-if="selectedItem === item.key" label="Quantity" v-model="item.quantity" prefix=""
                          :min="item.minQuantity" :max="item.maxQuantity?item.maxQuantity:undefined"
                          :suffix="getItem(item).trackUnits" :precision="getItem(item).precision" class="text-body-2"/>
                    <div v-else class="mr-1" :class="{'error--text':item.quantity<item.minQuantity || (item.maxQuantity && item.quantity > item.maxQuantity)}">
                        {{item.quantity | number(getItem(item).precision)}} {{getItem(item).trackUnits}}
                    </div>
                  </template>
                  <template v-slot:item.minQuantity="{item}">
                    <decimal-number-input  v-if="selectedItem === item.key" label="Min quantity" v-model="item.minQuantity" prefix=""
                          :suffix="getItem(item).trackUnits" :precision="getItem(item).precision" class="text-body-2" @change="$refs.form.validate()"/>
                    <div v-else class="mr-1" :class="{'error--text':item.minQuantity<0}">{{item.minQuantity | number(getItem(item).precision)}} {{getItem(item).trackUnits}}</div>
                  </template>
                  <template v-slot:item.maxQuantity="{item}">
                    <decimal-number-input  v-if="selectedItem === item.key" label="Max quantity" v-model="item.maxQuantity" prefix=""
                          :suffix="getItem(item).trackUnits" :precision="getItem(item).precision" class="text-body-2" @change="$refs.form.validate()"
                          hint="0 for no max"/>
                    <div v-else class="mr-1" :class="{'error--text':item.maxQuantity<0}">{{item.maxQuantity | number(getItem(item).precision)}} {{getItem(item).trackUnits}}</div>
                  </template>
                  <template v-slot:footer="{widths}">
                    <v-divider/>
                    <div @click="selectedItem = null" style="width:100%" class="py-2 px-0">
                      <div :style="'width:'+widths[0]+'px'" class="text-center">
                        <v-btn fab color="primary" x-small @click.stop="addItem" :disabled="!addOkay"><v-icon small>mdi-plus</v-icon></v-btn>
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </outlined-block>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" md="6">
              <v-textarea label="Production notes" v-model="mashBill.description" outlined dense no-resize rows="4" :rules="[fieldRules.maxLength(1000)]"/>
            </v-col>
          </v-row>

          <v-row v-if="$store.getters.company.allowPlanning">
            <v-col cols="12" md="6">
              <production-planning :planning="mashBill.productionPlanningInfo"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
    <inventory-items-quick-create v-model="itemCreate" @create="itemCreated"/>

  </div>
</template>

<script>
import sortableJS from 'sortablejs';
import InventoryItemsQuickCreate from '@/views/inventory/items/InventoryItemsQuickCreate'
import confirmLeave from '@/mixins/confirmLeave'
import ProductionPlanning from '@/views/production/ProductionPlanning'
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'ProductionMashingMashBillsEdit',
  mixins: [confirmLeave,createHierarchyList],
  components: {InventoryItemsQuickCreate,ProductionPlanning},
  props: {
    mashBillId: {type:String, required:false},
    copy: {type:Boolean, required:false}
  },
  data () {
    return {
      mashBill: {items:[],productionPlanningInfo:{equipmentTypes:[]}},
      items: [],
      categories: [],
      dirty: false,
      saving: false,
      loading: false,
      valid: true,
      selectedItem: null,
      itemsNeeded: items => items.length>0 || 'At least one item needs to be added to the mash bill',
      itemValid: itemId => itemId !== '' || 'Item needs to be specified',
      itemCreate: false,
      inputItem: null,
      sortable: null
    }
  },
  computed: {
    addOkay() {
      return !this.mashBill.items.some(item => item.itemId === '');
    },
    eligibleItems() {
      const categories = this.createHierarchyList(this.categories);
      for (const category of categories) {
        const sub = this.items.filter(item => item.category?.id === category.id);
        if (sub.length)
          category.menu = sub;
        else
          category.disabled = true;
      }
//      const items = [...categories.filter(category => !category.disabled)];
      const items = categories;
      const leftOver = this.items.filter(item => !item.category?.id);
      if (leftOver.length)
        items.push({divider:true},{name:'Other items',id:'x',menu:leftOver});
      return items;
    }
  },
  watch: {
    mashBill: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
  async created() {
    this.loading = true;
    this.$lazyListLoad(this.categories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Item'}]);
    this.$lazyListLoad(this.items, 'items2', 'id,name,trackUnits,type,precision,category{id}', 100, [{field:'active', comparator:'eq', value:'true'}]);
    if (this.mashBillId) {
      const results = await this.$apiCall(`query ProductionMashBillsEdit($id:ID!) {
                                                mashBill(id:$id) {
                                                  id,name,active,volume,scalable,description,items{itemId,quantity,minQuantity,maxQuantity},
                                                  productionPlanningInfo {useAverageDuration,specifiedDuration,equipmentTypes{id,quantity},roleId}
                                                }
                                              }`,
                                          {id:this.mashBillId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.mashBill = results.data.mashBill;
      let key = Date.now();
      this.mashBill.items.forEach(item => item.key = key++);
      if (this.copy) {
        delete this.mashBill.id;
        this.mashBill.active = true;
        this.mashBill.name = `COPY OF ${this.mashBill.name}`;
      }
    }

    else
      this.mashBill = {name:'',active:true,volume:0,scalable:false,description:'',items:[],
                      productionPlanningInfo:{useAverageDuration:true,specifiedDuration:0,equipmentTypes:[],roleId:''}};

    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },
  mounted() {
    const _self = this;
    this.sortable = sortableJS.create(this.$refs.tableBody.$el.querySelector('tbody'), {
      handle: '.handle',
      onEnd({newIndex, oldIndex}) {
        const rowSelected = _self.mashBill.items.splice(oldIndex, 1)[0];
        _self.mashBill.items.splice(newIndex, 0, rowSelected);
      }
    })
  },
  beforeDestroy() {
    this.sortable.destroy();
  },

  methods: {
    async itemCreated(item) {
      this.items = (await this.$store.dispatch('items')).filter(item => item.active);
      if (this.inputItem)
        this.inputItem.itemId = item.id;
    },
    elibigleItems(includeItemId) {
      return this.items.filter(item => item.id === includeItemId || !this.mashBill.items.some(i => i.itemId === item.id));
    },
    getItem(item) {
      return this.items.find(i => i.id === item.itemId) ?? {trackUnits:'', precision:0, name:'MISSING'};
    },
    addItem() {
      const item = {itemId:'',quantity:0,minQuantity:0,maxQuantity:0,key:Date.now()};
      this.mashBill.items.push(item);
      this.selectedItem = item.key;
      this.$nextTick(() => this.$refs.form.validate());
    },
    deleteItem(index) {
      this.mashBill.items.splice(index, 1);
    },
    cancel() {
      this.$router.back();
    },
    async save() {
      const incomplete = this.mashBill.items.some(item => !item.itemId ||
                                                          item.quantity < item.minQuantity || (item.maxQuantity && item.quantity > item.maxQuantity) ||
                                                          item.minQuantity < 0 || item.maxQuantity < 0);
      if (!this.valid || incomplete) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      const input = {...this.mashBill};
      input.items = input.items.map(item => {
        const {key,...itemInfo} = item;
        return itemInfo;
      });
      const results = await this.$apiCall(`mutation ProductionMashBillsEdit($input: MashBillInput!) {
                                             mashBillCreate(input:$input) {id}
                                           }`,
                                          {input})
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.mashBill.id?'Updated':'Created'} mash bill ${this.mashBill.name}`});
      }
    }
  }
}
</script>